import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable,throwError, catchError, of, Subject, tap} from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class TransactionService {
  private _RefreshDepositRequests$ = new Subject<void>();
  private _RefreshWithdrawRequests$ = new Subject<void>();

  constructor(private http: HttpClient) {
  }

  get refreshDepositRequests() {
    return this._RefreshDepositRequests$;
  }
  get refreshWithdrawRequests() {
    return this._RefreshWithdrawRequests$;
  }

  addTransaction(transaction_details: any) {
    return this.http.post(environment.base_url + "/add-transaction", transaction_details);
  }

  getTransactionDetails(user_id: number) {
    return this.http.get(environment.base_url + "/get-transaction-details/" + user_id);
  }

  addDepositRequest(request_details: any) {
    return this.http.post(environment.base_url + "/add-deposit-request", request_details).pipe(tap(() => {
      this._RefreshDepositRequests$.next();
    }));
  }

  addCasinoDepositRequest(request_details: any) {
    return this.http.post(environment.base_url + "/add-casino-deposit-request", request_details).pipe(tap(() => {
      this._RefreshDepositRequests$.next();
    }));
  }

  getDepositRequests() {
    let user_id = localStorage.getItem('user_id');
    return this.http.get(environment.base_url + "/get-user-deposit-request/" + user_id);
  }

  getCasinoDepositRequests() {
    let user_id = localStorage.getItem('user_id');
    return this.http.get(environment.base_url + "/get-casino-deposit-request/" + user_id);
  }

  addWithdrawRequest(request_details: any) {
    // return this.http.post<any>(environment.base_url + "/add-withdraw-request", request_details)
    // .pipe(catchError((err: any, caught: Observable<any>): Observable<any> => {
    //   console.log('catching error: ', err); // getting entire object here

    //   if (err.status === 400) {
    //       console.log('yeee');
    //   }

    //   const error = err.error.message || err.statusText;  // this is my problem.
    //   console.log('ll',error);
    //   return throwError(() => new Error(error));
    // }));
    return this.http.post(environment.base_url + "/add-withdraw-request", request_details).pipe(tap(() => {
      this._RefreshWithdrawRequests$.next();
    }));
  }

  addCasinoWithdrawRequest(request_details: any) {
    return this.http.post(environment.base_url + "/add-casino-withdraw-request", request_details).pipe(tap(() => {
      this._RefreshWithdrawRequests$.next();
    }));
  }

  getWithdrawRequests() {
    let user_id = localStorage.getItem('user_id');
    return this.http.get(environment.base_url + "/get-user-withdraw-request/" + user_id);
  }

  getCasinoWithdrawRequests() {
    let user_id = localStorage.getItem('user_id');
    return this.http.get(environment.base_url + "/get-casino-withdraw-request/" + user_id);
  }

  getUPI() {
    return this.http.get(environment.base_url + "/get-upi");
  }

  getPopupDataRequests() {
    return this.http.get(environment.base_url + "/get-popup/");
  }

  getProof(withdraw_id: number){
    return this.http.get(environment.base_url + "/get-withdraw-proofs/"+ withdraw_id);
  }

  getbetData(event_id: number,subtype:string,runner_name:string){
    return this.http.get(environment.base_url + "/bet-details/"+ event_id + "/" + subtype + "/" + runner_name);
  }

  getbetCount(){
    return this.http.get(environment.base_url + "/total-bets/");
  }
  getNewsDataRequests() {
    return this.http.get(environment.base_url + "/get-news/");
  }
  addPayInPayment(data:any){
    return this.http.post(environment.base_url+"/add-payment",data);
  }

  testpayment(data:any){
    return this.http.post(environment.base_url+"/init-payment",data);
  }
}
